const { createClientModuleProxy } = require("react-server-dom-turbopack/server.edge");

__turbopack_export_namespace__(createClientModuleProxy("[project]/node_modules/next/dist/esm/lib/metadata/metadata-boundary.js"));
